var path = 'areas/library/variables/views/variable_set_values.html';
var html = "<div class=row> <div class=col-xs-12> <div ng-show=vs> <variable-editor class=slick-grid-container-box ng-if=showVariableEditor data=variableEditorOptions tab=tab></variable-editor> <last-modified model=variableEditorOptions.variableSet></last-modified> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/library/variables/views/variable_set_values.html
// module id = 8783989250652777
// module chunks = 1